export function getFirestoreErrorCode(error) {
    return error?.code;
}
//# sourceMappingURL=error.js.map